import { apiClient } from "src/domains/http/api-client"
import { TRequestOptions } from "src/domains/http/http-types"

import { TFetchSessionsResponse } from "./session-types"

export async function fetchSessions(options?: TRequestOptions) {
  const response = await apiClient.get<TFetchSessionsResponse>(
    "/auth/account/sessions",
    options
  )

  return response.data
}
